"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var getFreeformAnswerOptions = (0, _memoize.default)(function (questionRecord) {
  return questionRecord.quickAnswers.map(function (answer) {
    return {
      text: answer,
      value: answer
    };
  }).toArray();
});

var FreeformQuickReply = function FreeformQuickReply(_ref) {
  var _onChange = _ref.onChange,
      question = _ref.question;

  if (!question.isFreeformQuickReply()) {
    return null;
  }

  var options = getFreeformAnswerOptions(question);
  return _react.default.createElement(_UIFormControl.default, {
    label: _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.quickAnswers"
    }),
    className: "m-bottom-3"
  }, _react.default.createElement(_UISelect.default, {
    className: "question-and-answer-form-quick-replies-input",
    allowCreate: true,
    multi: true,
    onChange: function onChange(e) {
      return _onChange(question.setFreeformAnswers(e.target.value));
    },
    defaultValue: options.map(function (option) {
      return option.value;
    }),
    options: options,
    placeholder: _I18n.default.text('composer-plugins.questionAndAnswer.addQuickAnswers')
  }));
};

FreeformQuickReply.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired
};
var _default = FreeformQuickReply;
exports.default = _default;
module.exports = exports.default;